import * as React from "react";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { Button } from "reactstrap";
library.add(faTimes);

interface IProps<T> {
    title: string,
    confirmMsg?: string,
    style?: React.CSSProperties,
    data?: T,
    onClick (data?: T) : void,
}

class RemoveButton<T> extends React.PureComponent<IProps<T>> {
    
    handleClick = () => {
        if (this.props.confirmMsg && !window.confirm(this.props.confirmMsg)) {
            return;
        }
        this.props.onClick(this.props.data);
    }
    
    render() {
        return (
            <Button color="link"
                className="ll-btn-remove"
                onClick={this.handleClick}
                title={this.props.title}
                style={this.props.style}
            >
                <FontAwesomeIcon icon="times" />
            </Button>
        );
    }
}

export default RemoveButton;
